import { render, staticRenderFns } from "./StudyResultDetailScoreTable.vue?vue&type=template&id=6fb1c2cc&scoped=true&lang=pug"
import script from "./StudyResultDetailScoreTable.vue?vue&type=script&lang=ts"
export * from "./StudyResultDetailScoreTable.vue?vue&type=script&lang=ts"
import style0 from "./StudyResultDetailScoreTable.vue?vue&type=style&index=0&id=6fb1c2cc&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb1c2cc",
  null
  
)

export default component.exports